import { triggerPaidListingVehicleSeenEvent } from 'Services/analytics/events';

export const TAG_NAME = 'paidListing';

export const PAID_LISTING_EVENTS = {
	[TAG_NAME]: triggerPaidListingVehicleSeenEvent,
};
